<template>
  <Posts :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import Posts from "@/modules/post/pages/search/components/posts/Posts"
import {useRoute} from "vue-router"

export default defineComponent({
  name: "Default",
  components: {
    Posts
  },
  setup() {
    const route = useRoute()
    let version = ref(0)

    let paramsQuery = reactive({
      channelId: parseInt(route.params["channel_id"]),
    })

    let params = {
      title: "Глобальный поиск",
      h1: "Глобальный поиск",
      page: "search",
      type_ids: [1, 5, 6, 7, 8, 9, 10, 12, 13, 14],
      channel_id: getChannelId(),
    }

    onMounted(() => {
      version.value++
    })

    function getChannelId() {
      return paramsQuery.channelId
    }

    return {
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
